/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import React, { FunctionComponent, useRef } from 'react';

import { OnepassItem } from 'client-code/onepass';

import { DimensionScaler } from '../../../../core/device/DimensionScaler';
import { Locale, LocaleKeys } from '../../../../core/locale';

const OnePassManagerListItem: FunctionComponent<{
    item: OnepassItem;
    shouldHideMetaData: boolean;
}> = ({ item, shouldHideMetaData }): JSX.Element => {
    const titleRef = useRef<HTMLDivElement>(null);
    const infoRef = useRef<HTMLDivElement>(null);

    const OPM_ITEM_WIDTH = DimensionScaler.getInstance().getScaledWidth(1213.5, false);

    const isOverflowed =
        (titleRef.current?.scrollWidth || 0) + (infoRef.current?.scrollWidth || 0) > OPM_ITEM_WIDTH;
    let titleTobeShown = item.title;
    if (item.isAdult && shouldHideMetaData)
        titleTobeShown = Locale.getString(LocaleKeys.GUIDE_TITLE_HIDDEN);
    else if (item.postpendedTitle) titleTobeShown = item.postpendedTitle;
    const streamType = item.videoResolution;

    return (
        <>
            <div ref={titleRef} className={`onepass-title${isOverflowed ? ' overflow' : ''}`}>
                {titleTobeShown}
            </div>
            {(item.channelNumber || streamType) && (
                <div ref={infoRef} className={`onepass-info`}>
                    {!isOverflowed && <>&nbsp;</>}
                    {'('}
                    {item.channelNumber}
                    {item.channelNumber && streamType && <>&nbsp;</>}
                    {item.videoResolution && (
                        <span className={`resolution-icon ${streamType}`}></span>
                    )}
                    {')'}
                </div>
            )}
        </>
    );
};

export default OnePassManagerListItem;
